module.exports = __webpack_public_path__ + "media/images/icon_list/add-275ed77892d10f0dbc667288ebbb4c4c.svg";